export enum SeverityLevel {
    log, 
    warn, 
    error
}